import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { NonMemberService } from '@malirang/api-client';
import { AlertService } from '@malirang/front-share';
import { AuthStore } from '../stores/auth.store';
import { isPlatformBrowser } from '@angular/common';

export const authGuard = () => {
  const nonMemberService = inject(NonMemberService);
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const alert = inject(AlertService);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return;
  }

  nonMemberService.nonMemberControllerGetChildAuth().subscribe({
    next: (res) => {
      if (res) {
        authStore.setChild(res);
      }
    },
    error: (err) => {
      alert
        .open({
          type: 'danger',
          title: '요청 시간 만료',
          content: `로그인 시간이 만료되었습니다.
          다시 로그인 해주세요.`,
          buttons: {
            confirm: { hidden: true },
            cancel: { text: '확인' },
          },
        })
        .closed.subscribe(() => {
          router.navigate(['/']);
        });
    },
  });
};
